// Our labels for event kinds (backend: companies/event_kinds.py).
export const KIND_LABELS: Record<string, string> = {
  new_company: "New company",
  board_change: "Board change",
  managing_director_change: "Managing director change",
  auditor_change: "Auditor change",
  procuration_change: "Procuration change",
  bankruptcy: "Bankruptcy",
  bankruptcy_ended: "Bankruptcy ended",
  restructuring: "Restructuring",
  restructuring_ended: "Restructuring ended",
  liquidation: "Liquidation",
  liquidation_ended: "Liquidation ended",
  forced_dissolution: "Forced dissolution",
  merger: "Merger",
  demerger: "Demerger",
  business_transfer: "Business transfer",
  share_issue: "Share issue",
  share_capital_decrease: "Share capital decrease",
  name_change: "Name change",
  registered_office_change: "Registered office change",
  line_of_business_change: "Line of business change",
  financial_statements: "Financial statements",
  beneficial_owners_filed: "Beneficial owners filed",
  removed: "Removed from register",
  significant_events: "Significant events in the year",
  events_after_year_end: "Events after year-end",
  going_concern_doubt: "Going-concern doubt",
  audit_remark: "Auditor's remark",
  employees_crossed_50: "Passed 50 employees",
  employees_crossed_250: "Passed 250 employees",
  revenue_growth: "Strong revenue growth",
  negative_equity: "Negative equity",
  hiring_surge: "Hiring surge",
  hiring_new_country: "Hiring in a new country",
};
